
import { useTranslation } from 'react-i18next';

const Hero = () => {
  const { t } = useTranslation();

  const navigateToVehicles = () => {
    window.REACT_APP_NAVIGATE('/vehicles');
  };

  return (
    <section 
      id="home"
      className="relative min-h-screen flex items-center justify-center bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.4)), url('https://public.readdy.ai/ai/img_res/ae108e66a0018541529e723fb4a8af33.jpg')`
      }}
    >
      <div className="container mx-auto px-4 text-center text-white relative z-10">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-7xl font-bold mb-4 sm:mb-6 leading-tight">
            <span className="text-yellow-400">{t('hero.title')}</span>
          </h1>
          
          <h2 className="text-lg sm:text-xl md:text-2xl lg:text-3xl font-semibold mb-4 sm:mb-6 text-gray-200">
            {t('hero.subtitle')}
          </h2>
          
          <p className="text-sm sm:text-base md:text-lg lg:text-xl mb-6 sm:mb-8 text-gray-300 max-w-3xl mx-auto leading-relaxed px-4">
            {t('hero.description')}
          </p>
          
          <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center items-center px-4">
            <button
              onClick={navigateToVehicles}
              className="w-full sm:w-auto bg-yellow-400 text-black px-6 sm:px-8 py-3 sm:py-4 rounded-full text-base sm:text-lg font-semibold hover:bg-yellow-300 transition-all duration-300 transform hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              {t('hero.cta')}
            </button>
            
            <a
              href="https://wa.me/237693695377"
              target="_blank"
              rel="noopener noreferrer"
              className="w-full sm:w-auto bg-green-600 text-white px-6 sm:px-8 py-3 sm:py-4 rounded-full text-base sm:text-lg font-semibold hover:bg-green-500 transition-all duration-300 transform hover:scale-105 flex items-center justify-center space-x-2 whitespace-nowrap"
            >
              <i className="ri-whatsapp-line text-lg sm:text-xl"></i>
              <span>{t('hero.whatsapp')}</span>
            </a>
          </div>
        </div>
        
        {/* Scroll indicator */}
        <div className="absolute bottom-4 sm:bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
          <i className="ri-arrow-down-line text-xl sm:text-2xl text-yellow-400"></i>
        </div>
      </div>
    </section>
  );
};

export default Hero;
